import { Model } from '@vuex-orm/core'

export default class Conversation extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'conversations'

  static primaryKey = '_id'

  // List of all fields (schema) of the conversation model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      account_id: this.attr(null),
      name: this.attr(null),
      // candidato associado à conversa, populado pela api ({ _id, name,
      // photo_media_url }); null enquanto ninguém foi associado
      candidate_id: this.attr(null),
      // channel of the conversation (whatsapp, sms, email, ...)
      type: this.attr(null),
      // the address itself: phone number in E.164, email, etc.
      contact_address: this.attr(null),
      assigned_user_id: this.attr(null),
      // liga/desliga o agente conversacional nesta conversa específica (o
      // agente ainda precisa estar habilitado na conta)
      is_agent_enabled: this.attr(null),
      is_read: this.attr(true),
      read_at: this.attr(null),
      last_message: this.attr(null),
      last_inbound_message_at: this.attr(null),
      last_interaction_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Conversation.js